import {
  GET_DISCONNECT_SCHEDULES,
  GET_DISCONNECT_SCHEDULES_RESPONSE,
  GET_DISCONNECT_SCHEDULES_FAIL,
  POST_DISCONNECT_SCHEDULE,
  POST_DISCONNECT_SCHEDULE_RESPONSE,
  POST_DISCONNECT_SCHEDULE_FAIL,
  POST_BATCH_DISCONNECT_SCHEDULES,
  POST_BATCH_DISCONNECT_SCHEDULES_RESPONSE,
  POST_BATCH_DISCONNECT_SCHEDULES_FAIL,
  PUT_DISCONNECT_SCHEDULE,
  PUT_DISCONNECT_SCHEDULE_RESPONSE,
  PUT_DISCONNECT_SCHEDULE_FAIL,
  DELETE_DISCONNECT_SCHEDULE,
  DELETE_DISCONNECT_SCHEDULE_RESPONSE,
  DELETE_DISCONNECT_SCHEDULE_FAIL,
  RESET,
} from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  data: {
    disconnectSchedulesList: {
      items: [],
      total: 0,
      page: 1,
      limit: 10,
      totalRows: 0,
    },
  },
  disconnectSchedulesTotalRows: 0,
  newDisconnectSchedule: {
    groupId: null,
    scheduledDisconnectDate: null,
    notes: "",
    isActive: true,
  },
  searchQuery: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return Object.assign({}, initialState);

    case GET_DISCONNECT_SCHEDULES:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case GET_DISCONNECT_SCHEDULES_RESPONSE:
      const newItems = Array.isArray(action.disconnectSchedules) ? action.disconnectSchedules : [];
      const newStateData = state.data;
      newStateData.disconnectSchedulesList.items = newItems;
      newStateData.disconnectSchedulesList.total = action.total || 0;
      newStateData.disconnectSchedulesList.page = action.page || 1;
      newStateData.disconnectSchedulesList.limit = action.limit || 10;
      const totalRows = action.total || newItems.length;

      return {
        ...state,
        data: newStateData,
        disconnectSchedulesTotalRows: totalRows,
        error: action.error,
        isLoading: false,
      };

    case GET_DISCONNECT_SCHEDULES_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case POST_DISCONNECT_SCHEDULE:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case POST_DISCONNECT_SCHEDULE_RESPONSE:
      return {
        ...state,
        postDisconnectScheduleError: null,
        isLoading: false,
      };

    case POST_DISCONNECT_SCHEDULE_FAIL:
      return {
        ...state,
        postDisconnectScheduleError: action.error,
        isLoading: false,
      };

    case PUT_DISCONNECT_SCHEDULE:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case PUT_DISCONNECT_SCHEDULE_RESPONSE:
      return {
        ...state,
        putDisconnectScheduleError: null,
        isLoading: false,
      };

    case PUT_DISCONNECT_SCHEDULE_FAIL:
      return {
        ...state,
        putDisconnectScheduleError: action.error,
        isLoading: false,
      };

    case DELETE_DISCONNECT_SCHEDULE:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case DELETE_DISCONNECT_SCHEDULE_RESPONSE:
      return {
        ...state,
        deleteDisconnectScheduleError: null,
        isLoading: false,
      };

    case DELETE_DISCONNECT_SCHEDULE_FAIL:
      return {
        ...state,
        deleteDisconnectScheduleError: action.error,
        isLoading: false,
      };

    case POST_BATCH_DISCONNECT_SCHEDULES:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case POST_BATCH_DISCONNECT_SCHEDULES_RESPONSE:
      return {
        ...state,
        postBatchDisconnectScheduleError: null,
        isLoading: false,
      };

    case POST_BATCH_DISCONNECT_SCHEDULES_FAIL:
      return {
        ...state,
        postBatchDisconnectScheduleError: action.error,
        isLoading: false,
      };

    default:
      return state;
  }
};
